import React, { useEffect, useState } from 'react';
import { contentAPI } from '../utils/api';

/**
 * "Good to Know" practical info block — dress code, parking, kids, gift cards,
 * accessibility. Renders inside the Contact / Visit Us section.
 */
const VisitInfo = () => {
  const [info, setInfo] = useState({ heading: 'Good to Know', items: [] });

  useEffect(() => {
    contentAPI.getVisitInfo().then((d) => setInfo(d || { heading: 'Good to Know', items: [] }));
  }, []);

  const items = info.items || [];
  if (!items.length) return null;

  return (
    <div className="mt-16 md:mt-20 pt-12 border-t border-gray-200" data-testid="visit-info">
      <p
        className="text-[10px] md:text-xs tracking-[0.45em] uppercase text-[#C9A86C] mb-3 text-center"
        style={{ fontFamily: 'var(--font-serif)' }}
      >
        Good to Know
      </p>
      <h3
        className="text-3xl md:text-4xl text-center mb-12"
        style={{ fontFamily: 'var(--font-serif)' }}
      >
        {info.heading || 'Good to Know'}
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-10 max-w-5xl mx-auto">
        {items.map((it, idx) => (
          <div key={idx} data-testid={`visit-info-${idx}`}>
            <p className="text-[11px] tracking-[0.3em] uppercase text-[#C9A86C] mb-2">
              {it.label}
            </p>
            <p className="text-gray-700 leading-relaxed">{it.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VisitInfo;
